import React from "react";

const ChevronDownSelect = () => (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1414 1.06956L8.07031 8.14062L0.999245 1.06956" stroke="#21211D" strokeWidth="1.5"/>
</svg>
);

export default ChevronDownSelect;
